import styled from "styled-components";
import { BASE_URL } from "../services/axiosInstance";

const FormatDescription = styled.div`

  span p:has(img) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  span p img{
    width: auto;
    height: auto;
    object-fit: contain;
    max-width: 100%;
  }
  
  span div figure a img, span div figure img {
    max-width: 100%;
  }

`;

export default function ReplaceMacro({input}){

   var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  var d = new Date();
  var fullYear = d.getFullYear();

  var namedMonth = months[d.getMonth()];
  
  let tempDesc;

if(input){

  tempDesc = input;
  
  //month
   tempDesc = tempDesc.replaceAll( "{month}", namedMonth + " ");
   tempDesc = tempDesc.replaceAll( "{Month}", namedMonth + " ");
   tempDesc = tempDesc.replaceAll( "{MONTH}", namedMonth + " ");

   //year
   tempDesc = tempDesc.replaceAll( "{year}", " " + fullYear);
   tempDesc = tempDesc.replaceAll( "{Year}", " " + fullYear);
   tempDesc = tempDesc.replaceAll( "{YEAR}", " " + fullYear);

   //domain
   tempDesc = tempDesc.replaceAll( "{domain_name}", BASE_URL);
}

  return(
      <FormatDescription>
      {tempDesc && 
      <span className=".fixing-desc-img" dangerouslySetInnerHTML={{ __html: tempDesc }} >
      </span>}
      </FormatDescription>
    )
}